function initBlogMasonry() {
	[].forEach.call(document.getElementsByClassName("masonry"), function (element) {
		var masonry = Masonry.data(element);
		if (window.innerWidth < 768) {
			if (masonry)
				masonry.destroy();
		}
		else {
			if (!masonry) {
				masonry = new Masonry(element, {stamp: ".stamp"});
				imagesLoaded(element, function(instance) {
					masonry.layout();
				});
			}
		}
	});
}

window.addEventListener("resize", initBlogMasonry);

initBlogMasonry();
